import React, { useState } from 'react';
import './OptimizedImage.css';

interface OptimizedImageProps {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  loading?: 'lazy' | 'eager';
  priority?: boolean;
}

const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  width,
  height,
  className = '',
  loading = 'lazy',
  priority = false
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    setIsLoaded(true);
  };

  const handleError = () => {
    setHasError(true);
  };

  // Tymczasowo wyłączamy automatyczną konwersję na WebP
  // const getWebPSrc = (originalSrc: string) => {
  //   if (originalSrc.includes('.jpg') || originalSrc.includes('.jpeg')) {
  //     return originalSrc.replace(/\.(jpg|jpeg)$/i, '.webp');
  //   }
  //   if (originalSrc.includes('.png')) {
  //     return originalSrc.replace(/\.png$/i, '.webp');
  //   }
  //   return originalSrc;
  // };

  // const webpSrc = getWebPSrc(src);

  return (
    <div className={`optimized-image-container ${className}`}>
      {!hasError && (
        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          loading={priority ? 'eager' : loading}
          className={`optimized-image ${isLoaded ? 'loaded' : ''}`}
          onLoad={handleLoad}
          onError={handleError}
          decoding="async"
        />
      )}
      {hasError && (
        <div className="image-error">
          <span>Błąd ładowania obrazu</span>
        </div>
      )}
    </div>
  );
};

export default OptimizedImage;
